module.exports = __webpack_public_path__ + "static/media/icon-kid-walk-grey.42ebd387.svg";